import { Action } from "./actionRepository";
import * as functionLib from "../lib/domFunctions";
import { addEvent } from "../lib/eventHandler";
import { fadeOut, fadeIn } from "../lib/slideFunction";

export interface PopParams {
    elementName: string;
    type: any;
    elementCSS: any;
    el: string;
    id: string;
    elementId: string;
    content: string;
    src: string;
}

export class PopAction implements Action {
    params: PopParams;

    constructor(params: PopParams) {
        this.params = params;
    }

    execute() {
        var overlay = functionLib.createElement(
            "div",
            {},
            {
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 999,
                // overflow: 'auto',
                display: "flex",
            },
        );

        var modal = functionLib.createElement(
            "div",
            { onclick: "event.stopPropagation()" },
            {
                margin: "auto",
            },
        );

        var content = functionLib.createElement("div", {}, { position: "relative" });

        var closebtn = functionLib.createElement(
            "button",
            {},
            {
                position: "absolute",
                backgroundColor: "#000",
                border: "2px solid #fff",
                color: "#fff",
                width: "40px",
                height: "40px",
                borderRadius: "20px",
                cursor: "pointer",
                top: "-10px",
                right: "-10px",
                padding: "0",
                fontSize: "28px",
            },
        );

        closebtn.innerHTML = "×";

        // var header = functionLib.createElement('h2', { id: "ug-title" }, { position:"absolute", top: "20%", left:"10%"});
        // var textNode = functionLib.textContent(this.params.content);

        document.body.appendChild(overlay);
        fadeIn(overlay);
        overlay.appendChild(modal);
        modal.appendChild(content);

        if (this.params.content) {
            const shadowHost = functionLib.createElement("div", {}, {});
            const shadow = shadowHost.attachShadow({ mode: "open" });

            shadow.innerHTML = this.params.content;
            content.appendChild(shadowHost);

            const styles = shadow.querySelectorAll("style");

            styles &&
                styles.forEach((style: HTMLElement) => {
                    const css = style.innerHTML;

                    if (css && css.indexOf("@import url(") > -1) {
                        const clonedStyle = style.cloneNode(true);
                        content.appendChild(clonedStyle);
                    }
                });
        } else if (this.params.src) {
            var iframe = functionLib.createElement(
                "iframe",
                { id: "ug-iframe", frameborder: 0, border: 0, src: this.params.src },
                { overflow: "auto", display: "block", width: "50vw", height: "50vh", borderRadius: "4px" },
            );

            content.appendChild(iframe);
        }
        content.appendChild(closebtn);

        // modal.appendChild(header);
        // header.appendChild(textNode);

        // var contentWin = iframe.contentWindow
        // console.log('ifcw',contentWin);
        // var doc = contentWin.document
        // console.log(doc);
        // doc.open()
        // doc.write(this.params.content)
        //
        // contentWin.document.body.style.margin = 0
        // contentWin.document.body.style.display = 'flex'
        //
        // // iframe.style.maxWidth = contentWin.document.body.scrollWidth + "px";
        // iframe.style.maxHeight = contentWin.document.body.scrollHeight + 'px'
        //
        // doc.close()

        addEvent(closebtn, "click", () => {
            fadeOut(overlay, function () {
                document.body.removeChild(overlay);
            });
        });

        /*
        addEvent(overlay, "click", () => {
            functionLib.removeElement(this.params.elementId);
        }); //Klicka utanför modal för att stänga overlay

        addEvent(window, "message", (event: any) => {
            if (event.data !== "") {
                // header.textContent = "Hej "+event.data;

                setTimeout(() => {
                    fadeOut(overlay);
                }, 5000);
                setTimeout(() => {
                    functionLib.removeElement(this.params.elementId);
                }, 8000);
            }
        }); //Skicka input för att stänga popup
        
        addEvent(document, "keyup", (event: any) => {
            if (event.keyCode == 27) {
                functionLib.removeElement(this.params.elementId); //Escape stänger overlay
            }
        });
        */
    }
}
